export const LOGIN_DELAY = parseInt(process.env.REACT_APP_FETCH_LOGIN_DELAY as string) || 10000
export const ROOM_DELAY = parseInt(process.env.REACT_APP_FETCH_ROOMS_DELAY as string) || 60000
export const FETCH_DELAY = parseInt(process.env.REACT_APP_FETCH_DELAY as string) || 20000
export const FETCH_RETRY = parseInt(process.env.REACT_APP_FETCH_RETRY as string) || 3
export const APP_HOST = (process.env.REACT_APP_HOST as string) || ''
